<div class="content-modal">
  <div
    fxLayout="row wrap"
    fxLayoutAlign="start"
    style="background-color: #f1e2d0 !important"
  >
    <div style="padding-top: 8px; padding-left: 8px" fxFlex>
    </div>
    <button mat-icon-button (click)="this.dialogRef.close()">
      <mat-icon class="mat-18">close</mat-icon>
    </button>
  </div>
  <mat-card
    class="mat-elevation-z0"
    style="
      padding-bottom: 32px;
      padding: 20px;
      background-color: #f5ebdc !important;
    "
    fxLayout="row wrap"
    fxLayoutAlign="center"
  >
    <div>
      <p style="text-align: left" *ngIf="!user">
        {{ "TRANSLATE.WELCOME" | translate }};
      </p>
      <p style="text-align: left" *ngIf="user">
        {{ "TRANSLATE.WELCOME" | translate }} {{ user?.bp_agent }};
      </p>

      <p
        class="w-100"
        style="text-align: left; padding-bottom: 10px; font-weight: bold"
      >
        {{ "TRANSLATE.HOW_LIKE_ORDER" | translate }}
      </p>

      <!-- <p *ngIf="selected != 'PD' && this.mode?.storeSelected?.id !=null" class="w-100 p-store"
        style="text-align: left; padding-bottom: 14px;" fxLayoutAlign=" center">
        <mat-icon color="accent" style="margin-right: 5px; position: relative;">store</mat-icon>
        <span>{{this.mode.storeSelected.name}} <a class="link-store" (click)=" toNavigateMap() "> Cambiar</a></span>
      </p> -->
      <p
        *ngIf="selected == 'PD' && this.user != null"
        class="w-100 p-store"
        style="text-align: left; padding-bottom: 14px"
        fxLayout="row wrap"
        fxLayoutAlign=" center"
      >
        <mat-icon color="accent" style="margin-right: 5px; position: relative"
          >home</mat-icon
        >
        <!--class="mat-icon-xmd"-->
        <span fxLayout="column">
          <!--<span>Tienda: {{getCaracteresText(this.mode?.storeSelected?.name)}}</span>-->
          <span
            >{{
              this.user.bp_addressSelected == 0 ||
              this.user.bp_addressSelected == "0"
                ? getCaracteresText(this.user.bp_address)
                : getCaracteresText(this.mode.addressSelected.name || "")
            }}
            <a class="link-delivery" (click)="openModalAddress()">
              {{
                this.user.bp_address == null
                  ? "TRANSLATE.ADD_ADDRESS"
                  : ("TRANSLATE.CHANGE" | translate)
              }}
            </a></span
          >
        </span>
      </p>
    </div>

    <div fxFlex="100" fxFlex.gt-xs="90">
      <div fxLayout="row wrap" ngClass.gt-md="m-0">
        <div
          fxFlex="100"
          fxFlex.md="100"
          fxFlex.sm="100"
          style="margin-top: 12px"
        >
          <!--<mat-card *ngIf="company?.pickup[2] == 1" class="light-block" fxLayout="row" fxLayoutAlign="start center"
            [class.light-block-selected]="selected == 'PD'" (click)="setOrderMode('PD')">-->
          <mat-card
            class="light-block"
            fxLayout="row"
            fxLayoutAlign="start center"
            [class.light-block-selected]="selected == 'PD'"
            (click)="setOrderMode('PD')"
          >
            <mat-icon
              class="mat-icon-xlg m-0"
              style="margin-right: 10px !important"
              [class.text-muted]="selected !== 'PD'"
              >moped
            </mat-icon>
            <div class="content">
              <p class="b-title">{{ "TRANSLATE.ORDER_HOME" | translate }}</p>
              <span class="text-muted m-0 b-subtitle">
                {{ "TRANSLATE.DELIVER_ORDER_WHEREVER" | translate }}.</span
              >
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </mat-card>
</div>
